import React from 'react';
import { connect } from 'react-redux';
import BgImage from './../dom-elements/BgImage';
import HeroSliderCaption from './HeroSliderCaption';
import { breakpoints } from './../../styles/theme.json';
import { returnOpacity } from './../../scripts';

const HeroSliderSlide = (props) => {
  //props.slideData.slideshow_photo.large
  let photo_desktop = props.slideData.slideshow_photo_full;
  if (props.height) {
    photo_desktop = props.slideData.slideshow_photo_short;
  }

  let photo_mobile = props.slideData.slideshow_photo_full;
  if (props.slideData.mobile_photo) {
    photo_mobile = props.slideData.mobile_photo;
  }

  const gradientStyle = {
    opacity: returnOpacity(props.slideData.slideshow_gradient_opacity)
  };

  return (
    <div className={'inner-slide'} style={(props.height) ? { height: props.height } : {height: '100vh'}}>
      <HeroSliderCaption caption={props.slideData.slideshow_caption} />
      <div className={'slide-wrapper'}>
        <div className="slide-gradient" style={gradientStyle}/>
        {(props.slideData.media_type == 'photograph')
          ? (props.window_width >= breakpoints.desktop)
            ? <BgImage source={photo_desktop} />
            : <BgImage source={photo_mobile} />
          : null
        }
        {props.children}
      </div>
      <style jsx>{`
        .inner-slide {
          width: 100vw;
          height: 100%;
          background: #FFF;
          position: relative;
          transform: translateZ(0);
        }
        .slide-wrapper {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 50;
          transform: translateZ(0);
        }
        .slide-gradient {
          content: '';
          width: 100%;
          height: 100%;
          background: linear-gradient(to bottom, rgba(76,76,76,1) 0%, rgba(255,255,255,0) 15%, rgba(255,255,255,0) 70%,  rgba(76,76,76,1) 100%);
          mix-blend-mode: multiply;
          position: absolute;
          bottom: 0;
          z-index: 10;
        }
      `}</style>
    </div>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(HeroSliderSlide);



// WEBPACK FOOTER //
// ./src/components/hero/HeroSwiperSlide.js